import {Component, ViewChild} from '@angular/core';
import {NavigationService} from "@shared/services/navigation-service.service";
import {NgxSpinnerService} from "ngx-spinner";
import {ActivatedRoute, Router} from "@angular/router";
import {cloneDeep} from "lodash";
import {RedemptionsService} from "@app/features/redemptions/redemptions.service";
import {RedeemModalComponent} from "@shared/redeem-modal/redeem-modal.component";

@Component({
  selector: 'app-redemptions',
  templateUrl: './redemptions.component.html',
  styleUrls: ['./redemptions.component.scss']
})
export class RedemptionsComponent {

  public params: any;
  public totalItems: any;
  public dataList: any;
  public PAGE_PATH = 'redemptions'
  public stateCount: any;
  public stateTotal: any;
  public stateCurrency: any;
  @ViewChild('redeemModal') redeemModal!: RedeemModalComponent;
  statusList = [
    {
      value: 'ALL',
      label: 'All'

    },
    {
      value: 'REDEEMED',
      label: 'Redeemed'
    },
    {
      value: 'ACTIVE',
      label: 'Purchased'
    }
  ]
  public totalPages: any;

  constructor(public redemptionsService: RedemptionsService,
              public navigation: NavigationService,
              public spinner: NgxSpinnerService,
              public router: Router,
              public route: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.spinner.show();
    this.initQueryParamMap();
  }

  public initQueryParamMap() {
    this.route.queryParamMap
      .subscribe((params: any) => {
          this.params = params.params.page ? cloneDeep(params.params) : {
            page: 1,
            srt: 'date',
            srtd: 'desc',
          };
          this.getItems();
        }
      );
  }


  public getItems() {
    this.redemptionsService.getRedemptions(this.params).subscribe((res: any) => {
      this.dataList = res.data;
      this.totalItems = res.total;
      this.totalPages =Math.ceil(parseInt(res.total.toString()) / 5);
      console.log(res)
      this.spinner.hide();

    }, error => {
      console.log(error);
      this.spinner.hide();

    });
    this.redemptionsService.getRedemptionsTotal(this.params).subscribe((res: any) => {
      this.stateTotal = res.total;
      this.stateCount = res.count;
      this.stateCurrency = res?.currency?.code || 'ILS';
    }, error => {
      console.log(error);
    });

  }

  backClick(event: any) {
    this.params.page--;
    this.navigation.refreshPage(this.PAGE_PATH, this.params);
  }

  nextClick(event: any) {
    this.params.page++;
    this.navigation.refreshPage(this.PAGE_PATH, this.params);
  }

  getpickerValues(event: any) {
    this.params.page = 1;
    if (event === 'all') {
      delete this.params.from;
      delete this.params.to;
      this.navigation.refreshPage(this.PAGE_PATH, this.params);
      return;
    }
    if (!event.toString().includes('object') && !event.toString().includes('empty')) {
      if (event.toString().split('|').length > 1) {
        this.params.from = event.toString().split('|')[0];
        this.params.to = event.toString().split('|')[1];
      } else {
        this.params.from = event.toString();
        this.params.to = event.toString();
      }
      this.navigation.refreshPage(this.PAGE_PATH, this.params);
    } else if (event.toString().includes('empty')) {
      delete this.params.from;
      delete this.params.to;
      this.navigation.refreshPage(this.PAGE_PATH, this.params);
    } else {
      delete this.params.from;
      delete this.params.to;
    }
  }

  changeFilter(value: any) {
    if (value !== 'ALL') {
      this.params.status = value;
    } else {
      delete this.params.status;
    }
    this.params.page = 1;
    this.navigation.refreshPage(this.PAGE_PATH, this.params);
  }

  doSearchByEnter(val: any) {
    this.params.page = 1;
    this.params.search = val?.target?.value;
    this.navigation.refreshPage(this.PAGE_PATH, this.params);

  }

  doSearchByKeyUp(event: any) {
    this.params.search = event.target.value;
    if (this.params.search.length > 3 && event.key !== 'Enter') {
      this.params.page = 1;
      this.navigation.refreshPage(this.PAGE_PATH, this.params);
    }
    if (this.params.search.length === 0) {
      delete this.params.search;
      this.navigation.refreshPage(this.PAGE_PATH, this.params);
    }
  }

  public goToDetails(id: any) {
    this.router.navigate(['/redemptions/' + id])
  }
  public onRedeem(data: { code: string; amount: number }) {
    this.redemptionsService.redeem(data.code, data.amount).subscribe(res => {
        this.redeemModal.handleRedeemSuccess();
        this.getItems(); // Refresh the list after successful redemption
      },
      error => {
        this.redeemModal.handleRedeemError();
        console.log(error);
      })
  }

  scanRedeem() {
    this.redeemModal.open();
  }

}
